import { Stepper } from '@vnetwork/ui/primitives';

/** The four wizard steps, in order. Labels are EN-first. */
export const WIZARD_STEPS = [
  { label: 'Check email', description: 'Verify uniqueness' },
  { label: 'Business info', description: 'Company & source' },
  { label: 'Contact info', description: 'Person & phone' },
  { label: 'Additional info', description: 'Context (optional)' },
];

/**
 * Thin wrapper over the @ui `Stepper` for the customer create wizard. `current`
 * is 0-based; past steps render complete (check mark), the active step is
 * highlighted. Navigation back to a reached step is enabled via `onStepClick`.
 */
export function WizardStepper({
  current,
  reached,
  onStepClick,
}: {
  current: number;
  reached: number;
  onStepClick?: (index: number) => void;
}) {
  return (
    <Stepper
      steps={WIZARD_STEPS}
      current={current}
      reached={reached}
      onStepClick={onStepClick}
      aria-label="New customer progress"
    />
  );
}
